import React, { useContext, useEffect, useState } from "react";
import Invoice from "./Invoice/Invoice";
import ThemeContext from "../../Context/theme/ThemeContext";
import axios from "axios";
import { BaseURL } from "../../Files/BaseURL";
import AlertContext from "../../Context/Alert/AlertContext";


const AmountHistory = () => {
  const { theme } = useContext(ThemeContext);

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [Data, setData] = useState(null);
  const [User, setUser] = useState({});
  const { showAlert } = useContext(AlertContext);
  const [auth] = useState(localStorage.getItem("p@token"));

  const extractDate = (timestamp) => {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const extractTime = (timestamp) => {
    const dateObj = new Date(timestamp);
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${ampm}`;
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${BaseURL}/api/transaction/getTransactions`, {
        headers: {
          "auth-token": auth,
          "Content-Type": "application/json",
        },
      });
      if (response) {
        setData(response.data);
      } else {
        showAlert("Error fetching data", "danger");
      }

      const userResponse = await axios.get(`${BaseURL}/api/getusers/getUser`, {
        headers: {
          "auth-token": auth,
          "Content-Type": "application/json",
        },
      });
      if (userResponse) {
        setUser(userResponse.data.user);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [auth]);


  return (
      <>
        {selectedInvoice && (
            <Invoice
                InvoiceModel={selectedInvoice}
                setInvoiceModel={() => setSelectedInvoice(null)}
                item={selectedInvoice}
                user = {User}
            />
        )}
        <div className="flex flex-col gap-2 overflow-x-scroll">
          <table className="border-spacing-y-4 border-separate">
            {Data && Data.length > 0 ? (
            <tbody>
            {Data && Data.map((item, index) => (
                <tr key={index} className="font-pop">
                  <td
                      className={`flex py-4 px-3 md:px-6 gap-4 rounded-l-2xl items-center
                    ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
                  >
                    <img
                        src={`../Assets/Prop/${
                            item.Offer.Seller._id === User._id ? "reciveicon.png" : "sendicon.png"
                        }`}
                        alt=""
                        className="w-6"
                    />
                    <h2 className="font-pop w-max font-medium">{item.Offer.Seller._id === User._id ? 'Received from' : 'Sent to' } {item.Offer.Seller._id === User._id ? <>{item.Offer.Buyer.FirstName} {item.Offer.Buyer.LastName}</>: <>{item.Offer.Seller.FirstName} {item.Offer.Seller.LastName}</>  }</h2>
                  </td>
                  <td
                      className={`py-4 px-3 md:px-6
                    ${theme === "dark" ? "bg-black text-white" : "bg-white"} 
                    ${item.Offer.Seller._id === User._id ? 'text-primarygreen':'text-red-400'}`}
                  >
                    <h2 className="w-max">{item.Offer.Seller._id === User._id ? '+' : '-'}{item.Offer.Price}</h2>
                  </td>
                  <td
                      className={`text-gray-400 text-sm py-4 px-3 md:px-6
                    ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
                  >
                    <h2 className="w-max">{extractDate(item.date)}</h2>
                  </td>
                  <td
                      className={`text-gray-400 text-sm py-4 px-3 md:px-6
                    ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
                  >
                    <h2 className="w-max">{extractTime(item.date)}</h2>
                  </td>
                  <td
                      className={`py-4 px-2 rounded-r-2xl 
                    ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
                  >
                    <img
                        src={`../Assets/Prop/download.png`}
                        alt=""
                        className="w-6"
                        onClick={() => {
                          setSelectedInvoice(item);
                        }}
                    />
                  </td>
                </tr>
            ))}
            </tbody>) : (<>No data found</>)}
          </table>
        </div>
      </>
  );
};

export default AmountHistory;
